import React from 'react';
import ErrorsPerGrammarChart from './ErrorsPerGrammarChart';
import { observer } from 'mobx-react';
import placementTestReportTestDialogService from '../../services/PlacementTesReportTestDialogService';

function DetailErrorsPerGrammarChartContainer() {
  return <ErrorsPerGrammarChart data={placementTestReportTestDialogService.errorsPerGrammar} />;
}

export default observer(DetailErrorsPerGrammarChartContainer);
